module.exports = __webpack_public_path__ + "img/portal-services-outline.df860f6a.svg";